import { AxiosPromise } from "axios"
import { AppApiResponseData } from "../types/api"
import http from "./http"

export function getUserChatToken(
	coach: string,
): AxiosPromise<AppApiResponseData> {
	return http({
		method: 'GET',
		url: `p/coach/${coach}/token`,
	})
}

export function getAllUserChannels(): AxiosPromise<AppApiResponseData> {
	return http({
		method: 'GET',
		url: `p/coach/chat/channels`,
	})
}

export function getPatientChat(
	coachId: string,
	patientId: string
): AxiosPromise<AppApiResponseData> {
	return http({
		method: 'GET',
		url: `p/patient/${coachId}/chat/channel/${patientId}`,
	})
}
